<template lang="html">
  <div class="_modals">
    <b-modal id="_rule__modal"
    ref="modalruleTerms"
    centered
    hide-header
    hide-footer
    title="">
      <div class="d-block text-center">
        <div class="_iframe">
          <b-embed
            type="iframe"
            src="https://bucket.andalin.com/assets/user-terms-and-condition.pdf"
            allowfullscreen
          ></b-embed>
        </div>
      </div>
      <div class="row">
        <div class="col-md text-center">
          <b-button @click="closeModal()" class="_modals__button mr-4">I Agree</b-button>
          <b-button @click="closeModal()" class="_modals__button ml-4">Not Agree</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal id="_rule__modal"
    ref="modalrulepolicy"
    centered
    hide-header
    hide-footer
    title="">
      <div class="d-block text-center">
        <div class="_iframe">
          <b-embed
            type="iframe"
            src="https://bucket.andalin.com/assets/user-privacy-policy.pdf"
            allowfullscreen
          ></b-embed>
        </div>
      </div>
      <div class="row">
        <div class="col-md text-center">
          <b-button @click="closeModal()" class="_modals__button mr-4">I Agree</b-button>
          <b-button @click="closeModal()" class="_modals__button ml-4">Not Agree</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal id="_rule__modal--termandcondition"
    ref="modalruleTermsAccepted"
    centered
    hide-footer
    title="">
      <div class="d-block text-center">
        <div class="_iframe">
          <b-embed
            type="iframe"
            src="https://bucket.andalin.com/assets/user-terms-and-condition.pdf"
            allowfullscreen
          ></b-embed>
        </div>
      </div>
    </b-modal>

    <b-modal id="_rule__modal--termandcondition"
    ref="modalrulepolicyAccepted"
    centered
    hide-footer
    title="">
      <div class="d-block text-center">
        <div class="_iframe">
          <b-embed
            type="iframe"
            src="https://bucket.andalin.com/assets/user-privacy-policy.pdf"
            allowfullscreen
          ></b-embed>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  created () {
    this.$eventHub.$on('dialog-rule-terms', this.dialogRuleTerms)
    this.$eventHub.$on('dialog-rule-policy', this.dialogRulePolicy)
    this.$eventHub.$on('dialog-rule-terms-accepted', this.dialogRuleTermsAccepted)
    this.$eventHub.$on('dialog-rule-policy-accepted', this.dialogRulePolicyAccepted)
  },
  beforeDestroy () {
    this.$eventHub.$off('dialog-rule-terms')
    this.$eventHub.$off('dialog-rule-policy')
    this.$eventHub.$off('dialog-rule-accepted')
    this.$eventHub.$off('dialog-rule-accepted')
  },
  methods: {
    closeModal: function () {
      this.$refs.modalruleTerms.hide()
      this.$refs.modalrulepolicy.hide()
      this.$refs.modalruleTermsAccepted.hide()
      this.$refs.modalrulepolicyAccepted.hide()
    },
    dialogRuleTerms: function () {
      this.$refs.modalruleTerms.show()
    },
    dialogRulePolicy: function () {
      this.$refs.modalrulepolicy.show()
    },
    dialogRuleTermsAccepted: function () {
      this.$refs.modalruleTermsAccepted.show()
    },
    dialogRulePolicyAccepted: function () {
      this.$refs.modalrulepolicyAccepted.show()
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/global/modals/Rule.vue